import { render, staticRenderFns } from "./AppRecommendVideos.vue?vue&type=template&id=56e9db50&scoped=true&"
import script from "./AppRecommendVideos.vue?vue&type=script&lang=js&"
export * from "./AppRecommendVideos.vue?vue&type=script&lang=js&"
import style0 from "./AppRecommendVideos.vue?vue&type=style&index=0&id=56e9db50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e9db50",
  null
  
)

export default component.exports